module.exports = "../../static/img/WARROOM icon new.b5881d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/WARROOM icon new.svg
// module id = UrRL
// module chunks = 1